export const EAppColors = {
  red: 'red',
  orange: 'orange',
  green: 'green',
  main: 'main'
}
